<template>
	<div>
		<ul class="list-optins">
			<li class="mb-5" v-for="(item, indexItem) in options" :key="indexItem">
				<vs-row>
					 <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="11">
					 	{{indexItem + 1}}
					 	<div class="radio mr-3 ml-3"></div>
					 	<div class="form-input w-full">
					 		<input type="text" class="option w-full" v-model="options[indexItem]">
					 	</div>
					 </vs-col>
					 <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
					 	<div class="closed" v-if="options.length > 1" @click="deleteOption(indexItem)">
					 		X
					 	</div>
					 </vs-col>
				</vs-row>
			</li>

			<li>
				<vs-row>
					 <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="12">
					 	<div class="radio mr-3"></div>
					 	<span class="addOption" @click="addOption">{{$t('MODULE.addOtherOption')}}</span>			 	
					 </vs-col>					
				</vs-row>
			</li>
		</ul>	
	</div>
</template>

<script type="text/javascript">
	import { mapState } from 'vuex';
	export default {
		props: ['index'],
		methods: {
			deleteOption(index) {
				this.questionsByPage[this.index].options.splice(index,1);
			},
			addOption() {
				this.questionsByPage[this.index].options.push(`Opción ${this.lengthOptions + 1}`);
			}
		},
		computed: {
			...mapState('resource',['questionsByPage']),
			lengthOptions() {
				return this.options.length;
			},
			options() {
				return this.questionsByPage[this.index].options;
			}			
		}

	}
</script>

<style type="text/css" lang="scss">
	$pimary: rgb(56,189,170);
	.list-optins {
		li {
			.addOption{
				color: #{$pimary};
				cursor:  pointer;
			}
			.radio{
				border-radius: 50%;
				width: 23px;
				height: 23px;
				border: 2px solid #D8D8D8;
			}

			.option {
				border: none;
				border-bottom: 1px solid #000000;
				height: 35px;
				font-size: 16px;
				// text-transform: lowercase;
				&:focus{
					border-bottom-color: #{$pimary};
				}
			}

			.closed {				
				padding: 10px 15px;				
				border-radius: 50%;				
				font-size: 18px;
				font-weight: bold;
				cursor: pointer;
				&:hover{
					background: #F2F2F2;
				}
			}
		}
	}
</style>